export const  fetcherUtils = async (url, init) => fetch(url, init).then(res=>res.json())